'use client'

import { useEffect } from 'react'

import { useBrowserNavigation } from '@marketplace-web/browser/browser-navigation-util'
import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import {
  orderEmailClickEvent,
  OrderEmailClickTarget,
} from '@marketplace-web/order-emails/order-emails-tracking-data'

type UseConversationOrderEmailTrackingParams = {
  transactionId: number | null | undefined
}

const useConversationOrderEmailTracking = ({
  transactionId,
}: UseConversationOrderEmailTrackingParams) => {
  const { click_target } = useBrowserNavigation().searchParams
  const { track } = useTracking()

  useEffect(() => {
    if (typeof click_target !== 'string') return
    if (!transactionId) return

    track(
      orderEmailClickEvent({
        transactionId: transactionId.toString(),
        target: click_target as OrderEmailClickTarget,
      }),
    )
  }, [transactionId, click_target, track])
}

export default useConversationOrderEmailTracking
